export default __webpack_public_path__ + "static/media/StatusArrived.e8ea36a8.svg";